<template>
  <Grid gtc="1fr minmax(275px, 1fr)" gap="12px">
    <Grid>
      <div class="text-heading-2 text-secondary-1">Total overview</div>
      <div class="text-caption-3 text-secondary-5">
        {{ data && data.active_subscription_count }} Active Subscriptions
      </div>
    </Grid>

    <Grid gtc="1fr auto" align-items="center" class="q-pl-lg">
      <div class="text-caption-3 text-secondary-1">Average price increase</div>
      <div class="text-heading-3 text-secondary-1 text-right">
        {{ data && formatPrice(data.average_price_increase) }} %
      </div>
    </Grid>
  </Grid>
</template>

<script>
export default {
  props: {
    data: {
      required: true
    }
  }
}
</script>
